import * as React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { MicrosoftGroupPermissionHOC } from '../dialogs/microsoftGroupPermission/hocs/MicrosoftGroupPermissionHOC/MicrosoftGroupPermissionHOC';

export class MicrosoftGroupPermissionView {
    el: Element;
    root: Root;
    store: Store;

    constructor (
        store: Store
    ) {
        this.store = store;
        if (this.el) this.remove();
        this.el = document.createElement('div');
        this.el.className = 'microsoft-groups-permission-placeholder';
        document.body.append(this.el);
        this.root = createRoot(this.el!);
        this.render();
    }

    render () {
        this.root.render(
            <Provider store={this.store}>
                <MicrosoftGroupPermissionHOC />
            </Provider>
        );
    }

    remove () {
        if (!this.el) return;

        this.root.unmount();
        this.el.remove();
        this.el = null;
    }
}
